var map = {
	"./pointer_battery_connection.png": 65451,
	"./pointer_battery_disconnect.png": 58445,
	"./pointer_default_alert.png": 95653,
	"./pointer_end_report.png": 62353,
	"./pointer_jamming.png": 78086,
	"./pointer_low_battery.png": 99877,
	"./pointer_sos.png": 62320,
	"./pointer_speeding.png": 91006,
	"./pointer_start_report.png": 3228,
	"./pointer_stop.png": 68993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77102;